import { SearchPublicPages } from '../../../components/SearchPublicPages/SearchPublicPages.js';

export const SearchPublicPagesPath = () => <SearchPublicPages />;
